import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Send, ArrowRight } from 'lucide-react';
import VkIcon from '../icons/VkIcon';
import ContactModal from '../ContactModal/ContactModal';
import './Footer.css';
import { useServices } from '../../hooks/useServices';

const companyLinks = [
  { label: 'Классификация машин', path: '/car-classification' },
  { label: 'Контроль качества', path: '/quality-control' },
  { label: 'Наши работы', path: '/our-works' },
  { label: 'Контакты', path: '/contacts' },
];

const socialLinks = [
  { key: 'instagram', href: 'https://www.instagram.com/moscow_garage_?igsh=Y2pvYW9kN29uZnUz', label: 'Instagram', Icon: Instagram },
  { key: 'vk', href: 'https://vk.ru/moscow.garage', label: 'ВКонтакте', Icon: VkIcon },
  { key: 'telegram', href: 'https://t.me/MoscowGarageDeteiling', label: 'Telegram', Icon: Send },
];

const Footer = () => {
  const { data: services = [] } = useServices();
  const [isContactOpen, setIsContactOpen] = useState(false);
  return (
    <footer className="footer">
      <div className="footer__left">
        <Link to="/" className="footer__logo">
          <span className="footer__logo-top">МОСКОУ</span>
          <span className="footer__logo-bottom">ГАРАЖ</span>
        </Link>

        <div className="footer__address">
          <p className="footer__address-title">Адрес в Москве</p>
          <p className="footer__address-text">Москва, Новомосковская улица, 1</p>
        </div>
      </div>

      <div className="footer__right">
        <div className="footer__top">
          <ul className="footer__links footer__links--services">
            {services.map((service) => (
              <li key={service.slug}>
                <Link to={`/services/${service.slug}`} className="footer__link">
                  {service.title}
                </Link>
              </li>
            ))}
          </ul>

          <ul className="footer__links footer__links--company">
            {companyLinks.map((item) => (
              <li key={item.path}>
                <Link to={item.path} className="footer__link">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__bottom">
          <div className="footer__socials">
            {socialLinks.map(({ key, href, label, Icon }) => (
              <a
                key={key}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label={label}
              >
                <Icon size={18} />
              </a>
            ))}
          </div>

          <div className="footer__contacts">
            <div className="footer__phones">
              <a href="tel:+79100002330" className="footer__phone">
                +7 (910) 000-23-30
              </a>
            </div>
            <p className="footer__mobile-address">Новомосковская, 1</p>
            <button type="button" className="footer__contact-btn" onClick={() => setIsContactOpen(true)}>
              <span>Связаться с нами</span>
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>

      <div className="footer__mobile-cta">
        <button type="button" className="footer__contact-btn" onClick={() => setIsContactOpen(true)}>
          <span>Связаться с нами</span>
          <ArrowRight size={18} />
        </button>
      </div>

      <div className="footer__mobile-links">
        <ul className="footer__links footer__links--services">
          {services.map((service) => (
            <li key={`mobile-${service.slug}`}>
              <Link to={`/services/${service.slug}`} className="footer__link">
                {service.title}
              </Link>
            </li>
          ))}
        </ul>

        <ul className="footer__links footer__links--company">
          {companyLinks.map((item) => (
            <li key={`mobile-${item.path}`}>
              <Link to={item.path} className="footer__link">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </footer>
  );
};

export default Footer;